<template>
  <div>
    <NoResults v-if="emptyStudents" class="m-4" />
    <div v-else v-for="(studentsForLetter, alphabetLetter) in students">
      <div class="bg-dark text-light p-2">{{ alphabetLetter }}</div>
      <div v-for="student in studentsForLetter" class="m-2 student-wrapper">
        <p class="student-name">
          {{ getStudentName(student.name) }}
        </p>

        <p class="student-details">
          Student #: {{ student.studentId }} Email: {{ student.email }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _startCase from "lodash/startCase";
import _isEmpty from "lodash/isEmpty";
import NoResults from "@/components/NoResults";

export default {
  name: "TmsStudents",
  components: { NoResults },
  computed: {
    ...mapGetters("tmsStore", ["students", "isLoading"]),
    emptyStudents() {
      return _isEmpty(this.students);
    },
  },
  methods: {
    getStudentName(rawName) {
      if (!rawName) return "Unnamed";
      else return _startCase(rawName);
    },
  },
};
</script>

<style scoped>
.student-wrapper {
  border-bottom: 1px solid #dee2e6;
}
.student-wrapper:last-child {
  border-bottom: 0;
}

.student-name {
  font-size: 1em;
  margin: 0;
}

.student-details {
  font-weight: lighter;
  font-size: 0.8em;
  margin: 2px 0 6px 0;
}
</style>
